import { render, staticRenderFns } from "./rightBarRt.vue?vue&type=template&id=1860b210&"
import script from "./rightBarRt.vue?vue&type=script&lang=js&"
export * from "./rightBarRt.vue?vue&type=script&lang=js&"
import style0 from "./rightBarRt.vue?vue&type=style&index=0&id=1860b210&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports